<template>
  <div class="category-staff-card--container">
    <div class="category-staff-card--title">
      Категория услуг:
    </div>
    <div class="category-staff-card--cat-container no-select">
      <div
          v-for="cat in list"
          :key="cat.id"
          class="category-staff-card--cat"
      >
        <div @click="toggleServices(cat.id)" class="category-staff-card--cat-item cursor-pointer">
          <div>{{cat.name}}</div>
          <div>
            <f-awesome
                v-show="cat.showServices"
                icon="angle-up"
            ></f-awesome>
            <f-awesome
                v-show="!cat.showServices"
                icon="angle-down"
            ></f-awesome>
          </div>
        </div>
        <div v-if="cat.showServices" class="category-staff-card--serv-container">
          <div
              v-for="serv in cat.services"
              :key="serv.id"
              class="category-staff-card--serv"
          >
            <div v-if="serv.subcategory == 0"  class="category-staff-card--serv-item">{{serv.name}}</div>
            <div v-if="serv.subcategory == 1" @click="toggleSubcat(serv.id)" class="category-staff-card--serv-item-subcat cursor-pointer">
              <div>{{serv.name}}</div>
              <div>
                <f-awesome
                    v-show="serv.showModification"
                    icon="angle-up"
                ></f-awesome>
                <f-awesome
                    v-show="!serv.showModification"
                    icon="angle-down"
                ></f-awesome>
              </div>
            </div>
            <div v-if="serv.showModification" class="category-staff-card--modif-container">
              <div
                  v-for="modif in serv.modification"
                  :key="modif.id"
                  class="category-staff-card--modif"
              >
                <div class="category-staff-card--modif-item">{{modif.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "CategoryStaffCard",
  components: {},
  data() {
    return {
      list: []
    };
  },
  props: {
    services: Array
  },
  watch: {
    services: function(val){
      this.filterServices(val);
    }
  },
  computed: {

  },
  methods: {
    toggleServices(catId){
      for(let key in this.list){
        if(+this.list[key].id === +catId){
          this.$set(this.list[key], 'showServices', !this.list[key].showServices);
        }
      }
    },
    toggleSubcat(servId){
      for(let key in this.list){
        for(let resServ in this.list[key].services){
          if(+this.list[key].services[resServ].id === +servId && +this.list[key].services[resServ].subcategory === 1){
            this.$set(this.list[key].services[resServ], 'showModification', !this.list[key].services[resServ].showModification);
          }
        }
      }
    },
    filterServices(data){
      let result = [];
      for(let key in data){
          if(+data[key].services.deleted === 0 && +data[key].services.categoryData.deleted === 0){
            // Найдем, есть ли уже такая категория в списке. Если нет, то добавим
            let existsCat = false;
            for(let sCat in result){
              if(+result[sCat].id === +data[key].services.categoryData.id){
                existsCat = true;
              }
            }
            if(!existsCat){
              result.push(data[key].services.categoryData);
            }
          }
      }
      for(let resKey in result){
        result[resKey].services = [];
      }
      // Теперь закинем услуги в категории
      for(let key in data){
          for(let resKey in result){
            if(+data[key].services.category_id === +result[resKey].id && +data[key].services.deleted === 0){
              let existsServ = false;
              for(let searchServ in result[resKey].services){
                if(+result[resKey].services[searchServ].id === +data[key].services.id){
                  existsServ = true;
                }
              }
              if(!existsServ){
                let service = data[key].services;
                delete service.categoryData;
                result[resKey].services.push(service);
              }
            }
          }
      }

      for(let resKey in result){
        for(let servKey in result[resKey].services){
          result[resKey].services[servKey].modification = [];
        }
      }

      for(let key in data){
        for(let resKey in result){
          for(let servKey in result[resKey].services){
            if(
                +data[key].service_id === +result[resKey].services[servKey].id &&
                +data[key].services.deleted === 0 &&
                +data[key].modification_id > 0
            ){
              let modif = data[key].modification;
              result[resKey].services[servKey].modification.push(modif);
            }
          }
        }
      }

      this.list = result;

      for(let resKey in this.list){
        this.$set(this.list[resKey], 'showServices', false);
        for(let resServ in this.list[resKey].services){
          this.$set(this.list[resKey].services[resServ], 'showModification', false);
        }
      }

    }
  },
  created() {
    if(this.services.length){
      this.filterServices(this.services);
    }
  }
};
</script>

<style scoped lang="less">
.category-staff-card--title{
  color: #41A2FC;
  font-size: 14px;
  font-weight: 500;
  padding: 11px 0;
}
.category-staff-card--cat-container{
  //text-align: center;

  .category-staff-card--cat{

    .category-staff-card--cat-item{
      margin-top: 4px;
      color: #fff;
      background-color: #7FA1CA;
      border-radius: 5px;
      padding: 6px 8px;
      box-shadow: 0px 2px 5px 0px rgba(65,162,252,0.25);
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      flex-direction: row;

      &>div:nth-of-type(1){
        width: 80%;
      }
      &>div:nth-of-type(2){
        width: 15%;
      }
    }
  }

  .category-staff-card--serv-container{
    padding-left: 15px;

    .category-staff-card--serv-item-subcat{
      margin-top: 4px;
      color: #fff;
      background-color: #7FA1CA;
      border-radius: 5px;
      padding: 6px 8px;
      box-shadow: 0px 2px 5px 0px rgba(65,162,252,0.25);
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      flex-direction: row;

      &>div:nth-of-type(1){
        width: 80%;
      }
      &>div:nth-of-type(2){
        width: 15%;
      }
    }
  }
  .category-staff-card--modif{
    padding-left: 15px;
  }
  .category-staff-card--serv-item, .category-staff-card--modif-item{
    background-color: #F0F4F9;
    color: #7FA1CA;
    margin-top: 4px;
    border-radius: 5px;
    padding: 6px 8px;
    box-shadow: 0px 2px 5px 0px rgba(65,162,252,0.25);
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    flex-direction: row;
  }
}
</style>
